module.exports = __webpack_public_path__ + "img/pdf_120.03bce04a.png";